<template>
  <div>
    <v-btn icon>
      <v-icon>
        mdi-help-circle
      </v-icon>
    </v-btn>
    <v-menu
      :offset-y="true"
      v-if="user"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          outlined
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
          {{ user.user.username }}
        </v-btn>
      </template>
  
      <v-list>
        <v-list-item to="/profile">
          <v-list-item-icon>
            <v-icon>
              mdi-cog
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Settings
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logOut">
          <v-list-item-icon>
            <v-icon>
              mdi-logout
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Logout
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn
      v-else
      outlined
      text
      to="/login"
    >
      <v-icon>mdi-login</v-icon>
      Login
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ProfileWidget',
  computed: {
    user() {
      return this.$store.state.auth.user
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout', this.user).then(
        () => {
            if (this.$router.path != '/')
              this.$router.push('/');
          },
          error => {
            this.loading = false;
            this.message = error.response.data.non_field_errors[0]
          }
        );
    }
  }
  
}
</script>
